/**
 * Deep clone a Javascript Object / Class Instance.
 * @param {any} input Object / Class.
 */
export function clone(input) {
    return Object.assign(Object.create(Object.getPrototypeOf(input)), input);
}